import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ApiService from '../services/ApiService';

const UpdateRequest = () => {
  const { requestId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkRequestState = async () => {
        try {
            setLoading(true);
            
            console.log('🔍 Checking request state for ID:', requestId);
            
            if (!requestId || requestId === 'undefined') {
                setError('Invalid request ID provided.');
                setLoading(false);
                return;
            }
            
            let requestData;
            let isAGNFirewall = false;
            
            try {
                // Try AGN Firewall endpoint first
                console.log('🟠 Trying AGN Firewall endpoint...');
                requestData = await ApiService.get(`/api/agn-firewall/${requestId}`);
                isAGNFirewall = true;
                console.log('✅ Found AGN Firewall request:', requestData);
            } catch (agnError) {
                console.log('❌ AGN not found, trying bandwidth endpoint...');
                try {
                    requestData = await ApiService.get(`/api/requests/${requestId}`);
                    isAGNFirewall = false;
                    console.log('✅ Found Bandwidth request:', requestData);
                } catch (bandwidthError) {
                    console.error('❌ Request not found in either endpoint:', bandwidthError);
                    setError(`Request not found: ${bandwidthError.message}`);
                    setLoading(false);
                    return;
                }
            }
            
            if (isAGNFirewall) {
                // 🔧 FIX: Check AGN state BEFORE redirecting
                const currentState = requestData.requestState || 
                                  requestData.request_state || 
                                  'Unknown';
                
                console.log('🟠 AGN Firewall request state:', currentState);
                
                // 🔧 KEY FIX: Only redirect if state is Draft
                if (currentState === 'Draft') {
                    console.log('✅ AGN request in Draft, allowing edit');
                    navigate(`/new-request?updateId=${requestId}&type=agn_firewall`);
                } else {
                    // 🔧 SHOW ERROR MESSAGE instead of redirecting
                    console.log('❌ AGN request not in Draft state:', currentState);
                    setLoading(false);
                    setError(`Only draft requests can be fully edited. Current state: ${currentState}`);
                }
            } else {
                // Bandwidth request logic (unchanged)
                const currentState = requestData.request_state;
                console.log('🔵 Bandwidth request state:', currentState);
                
                if (currentState === 'Draft') {
                    console.log('✅ Bandwidth request in Draft, allowing edit');
                    navigate(`/new-request?updateId=${requestId}`);
                } else {
                    setLoading(false);
                    setError(`Only draft requests can be fully edited. Current state: ${currentState}`);
                }
            }
        } catch (err) {
            console.error('❌ Error fetching request:', err);
            setError(`Failed to load request details: ${err.message}`);
            setLoading(false);
        }
    };

    checkRequestState();
  }, [requestId, navigate]);

  if (loading) {
    return (
      <Layout>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
        </Box>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <Box mt={4} textAlign="center">
          <Typography variant="h5" color="error" gutterBottom>
            Update Not Allowed
          </Typography>
          <Typography variant="body1" sx={{ mb: 2 }}>
            {error}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            Only draft requests can be fully edited. Please go back to Track Requests page.
          </Typography>
          <Box mt={2}>
            <button 
              onClick={() => navigate('/track-requests')}
              style={{ 
                padding: '8px 16px', 
                background: '#003781', 
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Back to Track Requests
            </button>
          </Box>
        </Box>
      </Layout>
    );
  }

  return null; // We shouldn't reach here as we'll redirect
};

export default UpdateRequest;